import { Checkbox } from '@react-spectrum/s2';

import { cn } from '@/utils/cn';

interface TileSelectionCheckboxProps {
	label: string;
	isSelected: boolean;
	onToggle: () => void;
}

// The whole tile is clickable and opens the draft. Spectrum's Checkbox fires its
// press on pointerdown and does not stop propagation, so a click-only guard would
// still let the tile's onClick run and navigate away mid-selection. Both events
// have to be swallowed here.
export const TileSelectionCheckbox = ({
	label,
	isSelected,
	onToggle,
}: TileSelectionCheckboxProps) => (
	<div
		className={cn(
			'absolute top-1.5 left-1.5 rounded-sm bg-white/80 p-0.5',
			'transition-opacity duration-150',
			// Revealed on hover so the grid reads as artwork at rest. Three states
			// keep it usable: a ticked box stays visible once the pointer leaves
			// (otherwise the selection becomes invisible), and focus-within keeps it
			// reachable by keyboard, which hover alone never is. pointer-events are
			// dropped while hidden so it is never an invisible click target.
			isSelected
				? 'opacity-100'
				: `pointer-events-none opacity-0 group-hover:pointer-events-auto
					group-hover:opacity-100 focus-within:pointer-events-auto
					focus-within:opacity-100`,
		)}
		data-testid="tile-select-checkbox"
		onPointerDown={(e) => e.stopPropagation()}
		onClick={(e) => e.stopPropagation()}
	>
		<Checkbox
			aria-label={`Select ${label}`}
			isSelected={isSelected}
			onChange={onToggle}
		/>
	</div>
);
